<div>
  <div v-if="spinner" :class="$style.pageMargin">
    <animation-processing fill="new-blue" :class="$style.pageSpinner"></animation-processing>
    <span class="mt-serif mt-serif--size3">
      {{$t('pages.contract.spinner.signed_agreement')}}
    </span>
  </div>
  <div v-else class="mt-wrapper">
    <div v-if = "contractHTML.template === ''"> {{$t('pages.contract.no_contract_desc')}} </div>
    <div v-else>
      <div v-if="contractHTML.contractType === 'UFDA'">
        <h1 class="mt-h1-fda">
          Font Distribution Agreement
        </h1>
        <div class="injectedHTML" v-html="setNewTemplate(contractHTML.template)"></div>
        <div v-html="contractHTML.dynamicTemplate"></div>
      </div>
      <div v-else><div class="injectedHTML" v-html="setNewTemplate(contractHTML.template)"></div></div>
    </div>
  </div>
</div>